import { AnyAction, applyMiddleware, combineReducers, compose, createStore, Store } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import thunk from 'redux-thunk';
import { searchReducer } from './components/Search/reducers';
import { isDev } from './config';
import globalInteraction from './globalInteraction';
import { RootState } from './interfaces';
import { routerReducer } from './routes/redux/reducer';
import { appReducer, authReducer } from './views/app/reducers';
import { programArchiveReducer } from './views/programarchive/reducers';
// reducers
import { pvrReducer } from './views/pvr/reducers';
import { svodReducer } from './views/svod/reducers';
import { channelsReducer } from './views/tv/reducers';
import { vodReducer } from './views/vod/reducers';

let composeEnhancers = compose;

if (isDev) {
  const reduxDevtools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  if (reduxDevtools) {
    composeEnhancers = reduxDevtools({ serialize: true });
  }
} else {
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
    for (let [key, value] of Object.entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof value == 'function' ? () => undefined : null;
    }
  }
}

export const store = createStore(
  enableBatching(
    combineReducers({
      app: appReducer,
      router: routerReducer,
      authReducer,
      channelsReducer,
      pvrReducer,
      vodReducer,
      svodReducer,
      programArchiveReducer,
      searchReducer,
    }),
  ),
  composeEnhancers(applyMiddleware(thunk)),
);

globalInteraction(store as {} as Store<RootState, AnyAction>);
